import { Space, Text, WithEllipsisTooltip } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { type IConversationOrderSummaryItem } from './ConversationOrderSummary'
import { ConversationOrderSummaryStepper } from './ConversationOrderSummaryStepper'
import { ConversationOrderSummaryThumbnail } from './ConversationOrderSummaryThumbnail'

export interface IConversationOrderSummaryItemProps {
  item: IConversationOrderSummaryItem
  currency: CurrencyName
  disabled?: boolean
  isRemoveDisabled?: boolean
  onIncrement: (itemId: string) => void
  onDecrement: (itemId: string) => void
  onRemove: (itemId: string) => void
}

export const ConversationOrderSummaryItem = ({
  item,
  currency,
  disabled,
  isRemoveDisabled,
  onIncrement,
  onDecrement,
  onRemove,
}: IConversationOrderSummaryItemProps) => (
  <Space direction='horizontal' align='center' size='large'>
    <Space.Item grow={1} minWidth={0}>
      <Space direction='horizontal' align='center' size='small'>
        <ConversationOrderSummaryThumbnail img={item.img} />
        <Space.Item grow={1} minWidth={0}>
          <WithEllipsisTooltip title={item.name}>
            <Text noWrap textEllipsis className='fs-mask'>
              {item.name}
            </Text>
          </WithEllipsisTooltip>
        </Space.Item>
      </Space>
    </Space.Item>
    <ConversationOrderSummaryStepper
      item={item}
      disabled={disabled}
      isRemoveDisabled={isRemoveDisabled}
      onIncrement={onIncrement}
      onDecrement={onDecrement}
      onRemove={onRemove}
    />
    <span className='fs-mask'>
      <Price inline price={item.price} currency={currency} />
    </span>
  </Space>
)
